'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _saveSearchLocation = require('../../redux/modules/saveSearchLocation');

var _components = require('../../components');
var _constants = require('../../constants');

var _PropertySearchService = require('../../services/PropertySearchService');var _PropertySearchService2 = _interopRequireDefault(_PropertySearchService);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _SavedSearches = require('./SavedSearches.scss');var styles = _interopRequireWildcard(_SavedSearches);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Styles
var SavedSearches = function (_Component) {_inherits(SavedSearches, _Component);function SavedSearches() {var _temp, _this, _ret;_classCallCheck(this, SavedSearches);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.




    applySearch = function (data) {var
      drawn = data.drawn;
      if (drawn) {
        try {
          var polygonData = JSON.stringify({ coords: drawn });
          _constants.storage.value.setItem('polygonCoordinates', polygonData);
        } catch (err) {
          console.error(err);
        }
        // Directed by Robert B. Weide
        data.loadedWithPolygon = true;
      }
      var url = _PropertySearchService2.default.parseResponseToUrl(data);
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, url));
    }, _this.

    mergeData = function () {var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var agents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];return searches.map(function (search) {
        var smartAgent = agents.find(function (agent) {return search.id === agent.property_search_id;});
        return smartAgent ? Object.assign({},

        search, {
          smartAgentIsActive: smartAgent.active,
          smartAgentId: smartAgent.id,
          email: smartAgent.email }) : Object.assign({},

        search);
      });}, _this.

    toggleAgentState = function (agentId, state, searchId) {
      var data = agentId ? { active: state } : { data: { id: searchId } };

      _this.props.toggleSmartAgentState({
        id: agentId,
        email: _this.props.userEmail,
        token: _this.props.userToken,
        data: data });

    }, _this.

    renderSearches = function () {return (
        _react2.default.createElement(_components.SavedSearchesList, {
          titlesRef: _this.additionalTitlesRef,
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          translate: _this.props.translate,
          savedSearches: _this.mergeData(_this.props.savedSearches, _this.props.smartAgents),
          applySearch: _this.applySearch,
          toggleSmartAgentState: _this.toggleAgentState,
          removeSearch: function removeSearch(id, agentId) {return _this.props.deleteSavedSearchData({ id: id, agentId: agentId, token: _this.props.userToken });} }));}, _temp), _possibleConstructorReturn(_this, _ret);}SavedSearches.prototype.componentWillMount = function componentWillMount() {this.props.loadSavedSearchData({ token: this.props.userToken });};SavedSearches.prototype.



  render = function render() {var _this2 = this;
    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        !this.props.withoutTitle &&
        _react2.default.createElement('div', { className: styles.title },
          _react2.default.createElement(_components.OMTitle, {
            title: this.props.translate('editProfile', 'mySearches'),
            className: 'pageTitle' })),



        _react2.default.createElement('div', { className: styles.savedSearches },
          !this.props.isMobile &&
          _react2.default.createElement('div', { className: styles.titles },
            _react2.default.createElement('div', null,
              _react2.default.createElement('div', null, this.props.translate('savedSearches', 'title'))),

            _react2.default.createElement('div', { className: styles.rightCol, ref: function ref(_ref) {_this2.additionalTitlesRef = _ref;} },
              _react2.default.createElement('div', null, this.props.translate('savedSearches', 'email')),
              _react2.default.createElement('div', null, this.props.translate('savedSearches', 'created')),
              _react2.default.createElement('div', null,
                _react2.default.createElement('span', null, this.props.translate('savedSearches', 'smartAgent')),
                _react2.default.createElement(_components.BottomTooltip, {
                  className: 'smartAgentTooltip',
                  msg: this.props.translate('savedSearches', 'smartAgentDescription'),
                  icon: _react2.default.createElement('span', { className: 'icon icon-about' }),
                  showOnHover: true })),


              _react2.default.createElement('div', null, this.props.translate('savedSearches', 'frequency')))),



          this.props.loading ?
          _react2.default.createElement('div', { className: styles.spinnerPosition }, _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) })) :
          this.renderSearches())));




  };return SavedSearches;}(_react.Component);


SavedSearches.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  withoutTitle: _propTypes2.default.bool,
  savedSearches: _propTypes2.default.array,
  smartAgents: _propTypes2.default.array,
  loadSavedSearchData: _propTypes2.default.func,
  toggleSmartAgentState: _propTypes2.default.func,
  deleteSavedSearchData: _propTypes2.default.func,
  userEmail: _propTypes2.default.string,
  userToken: _propTypes2.default.string };



var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    userEmail: (0, _get2.default)(state, 'userAuthentication.data.email'),
    loading: state.saveSearchLocation.loading,
    savedSearches: state.saveSearchLocation.data,
    smartAgents: state.saveSearchLocation.smartAgents };};


var mapDispatchToProps = {
  loadSavedSearchData: _saveSearchLocation.loadSavedSearchData,
  deleteSavedSearchData: _saveSearchLocation.deleteSavedSearchData,
  toggleSmartAgentState: _saveSearchLocation.toggleSmartAgentState };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
SavedSearches);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SavedSearches/SavedSearches.js
// module id = 3019
// module chunks = 0